

const useTCNoValidation = () => {



  const validateTcKimlikNo = (tcKimlikNo) => {
    const trimmedTcKimlikNo = tcKimlikNo.trim();
    if (trimmedTcKimlikNo.length !== 11) {
      return false
    }

    const digits = trimmedTcKimlikNo.split("").map(Number);
    const weightedSum =
      digits[0] +
      digits[1] +
      digits[2] * 2 +
      digits[3] * 3 +
      digits[4] * 4 +
      digits[5] * 5 +
      digits[6] * 6 +
      digits[7] * 7 +
      digits[8] * 8 +
      digits[9] * 9;

    const checkDigit = weightedSum % 10 === 0 ? 0 : weightedSum % 10;
    if(digits[10] === checkDigit){
      return true;
    }
    return true
  };

  return {validateTcKimlikNo };
};

export default useTCNoValidation;